/* global FB */
import ProjectConfig from 'ProjectConfig';
import {
  initFacebookSdk,
} from 'Utils/thirdParty/marketingToolScripts';

const logEvent = (eventName, ...args) => {
  if (!window?.FB) {
    return null;
  }

  if (eventName === 'purchase') {
    FB?.AppEvents?.logPurchase.apply(this, [args]);
  } else {
    FB?.AppEvents?.logEvent?.apply(this, [eventName, ...args]);
  }
  
  // DEBUG aktifse console event atıldığına dair log basılıyor
  if (ProjectConfig.DEBUG) {
    console.info(`FB App Events Logged[${eventName}]`, args);
  }
};

export const purchaseEvent = (purchaseAmount, currency, transactionId) => {
  if (!window?.FB) {
    return null;
  }

  const { CONTENT } = FB.AppEvents.ParameterNames;

  logEvent('purchase', purchaseAmount, currency, {
    [CONTENT]: transactionId,
  });
};

export const completeRegistrationEvent = registrationMethod => {
  if (!window?.FB) {
    return null;
  }

  const { COMPLETED_REGISTRATION } = FB.AppEvents.EventNames;
  const { REGISTRATION_METHOD } = FB.AppEvents.ParameterNames;

  logEvent(COMPLETED_REGISTRATION, null, {
    [REGISTRATION_METHOD]: registrationMethod,
  });
};

export const addToCartEvent = (contentData, contentId, contentType, currency, price) => {
  if (!window?.FB) {
    return null;
  }

  const { ADDED_TO_CART } = FB.AppEvents.EventNames;
  const { CONTENT, CONTENT_ID, CONTENT_TYPE, CURRENCY } = FB.AppEvents.ParameterNames;

  logEvent(ADDED_TO_CART, price, {
    [CONTENT]: contentData,
    [CONTENT_ID]: contentId,
    [CONTENT_TYPE]: contentType,
    [CURRENCY]: currency,
  });
};

export const viewContentEvent = (contentType, contentData, contentId, currency, price) => {
  if (!window?.FB) {
    return null;
  }
  const { VIEWED_CONTENT } = FB.AppEvents.EventNames;
  const { CONTENT, CONTENT_ID, CONTENT_TYPE, CURRENCY } = FB.AppEvents.ParameterNames;

  logEvent(VIEWED_CONTENT, price ? price : 0, {
    [CONTENT]: contentData,
    [CONTENT_ID]: contentId,
    [CONTENT_TYPE]: contentType,
    [CURRENCY]: currency,
  });
};

export const trackContentView = event => {
  const { eventLeague, eventName, eventId, price } = event;

  initFacebookSdk()
    .then(() => {
      if (!window?.FB?.AppEvents) return;
      viewContentEvent(eventLeague, eventName, eventId, 'TRY', price);
    })
    .catch(() => {
      // bilinçli olarak boş: SDK yok / engelli / geç yüklenmiş olabilir
    });
};

